var _g, _path, _circle, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChangeEmailSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23430_239160)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 70,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 47.5H68C60.5 47.5 55.5 51.25 55.5 60V77.5C55.5 86.25 60.5 90 68 90H76.925C78.4 90 79.6 88.7 79.4 87.225C79.15 85.45 79.2 83.6 79.575 81.7C80.9 75.2 86.25 70.025 92.8 68.95C96.075 68.425 99.2 68.875 101.95 70.075C103.625 70.8 105.5 69.65 105.5 67.825V60C105.5 51.25 100.5 47.5 93 47.5ZM94.175 61.475L86.35 67.725C84.7 69.05 82.6 69.7 80.5 69.7C78.4 69.7 76.275 69.05 74.65 67.725L66.825 61.475C66.025 60.825 65.9 59.65 66.525 58.825C67.175 58.025 68.35 57.875 69.15 58.525L76.975 64.775C78.875 66.3 82.1 66.3 84 64.775L91.825 58.525C92.625 57.875 93.825 58 94.45 58.825C95.1 59.65 94.975 60.825 94.175 61.475Z",
    fill: "#292A2E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 84.5,
    r: 12.5,
    fill: "#00AC56"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23430_239160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 80.75L93.125 87.625L90 84.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23430_239160",
    x: 0.5,
    y: 0,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23430_239160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23430_239160",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23430_239160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(87.5 77)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChangeEmailSuccess);
export default __webpack_public_path__ + "static/media/ic_change_email_success.996d5866665b9089506c299ad83ad126.svg";
export { ForwardRef as ReactComponent };